import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { HolidayDetailPageModule } from '../booking-flow/holiday/holiday-detail-page/holiday-detail-page.module';
import { CruiseDetailPageModule } from '../booking-flow/cruise/cruise-detail-page/cruise-detail-page.module';
import { CustomPageModule } from '../pages/custom-page/custom-page.module';
import { LandingComponent } from './landing.component';
import { LandingCustomComponent } from './components/landing-custom/landing-custom.component';
import { LandingSitePageComponent } from './components/landing-site-page/landing-site-page.component';
import { LandingHolidayComponent } from './components/landing-holiday/landing-holiday.component';
import { LandingCruiseComponent } from './components/landing-cruise/landing-cruise.component';
import { NewsletterLandingPageModule } from '../pages/newsletter-landing-page/newsletter-landing-page.module';




const routes: Routes = [
  {
    path: '',
    data: { name: 'Landing' },
    component: LandingComponent,
    children: [
      {
        path: 'vacanze',
        data: {name: 'Vacanze', canNavigate: true},
        component: LandingHolidayComponent,
        children: [
          {
            path: '**',
            component: LandingHolidayComponent
          }
        ]
      },
      {
        path: 'crociere',
        data: {name: 'Crociere', canNavigate: true},
        component: LandingCruiseComponent,
        children: [
          {
            path: '**',
            component: LandingCruiseComponent
          }
        ]
      },
      {
        path: 'news',
        data: {name: 'News', cmsPath: 'landing-page', canNavigate: true},
        children: [
          {
            path: ':id/:title',
            component: LandingSitePageComponent
          }
        ]
      },
      {
        path: 'destinazione',
        data: {name: 'Destinazione', cmsPath: 'landing-page', canNavigate: true},
        children: [
          {
            path: ':id/:title',
            component: LandingSitePageComponent
          }
        ]
      },
      {
        path: 'offerte',
        data: {name: 'Offerte', cmsPath: 'landing-page', canNavigate: true},
        children: [
          {
            path: ':id/:title',
            component: LandingSitePageComponent
          }
        ]
      },
      {
        path: 'le-nostre-proposte',
        data: {name: 'Le nostre proposte', cmsPath: 'landing-page', canNavigate: true},
        children: [
          {
            path: ':id/:title',
            component: LandingSitePageComponent
          }
        ]
      },
      {
        path: 'custom',
        data: {name: 'Prodotto', canNavigate: true},
        component: LandingCustomComponent,
        children: [
          {
            path: '**',
            component: LandingCustomComponent
          }
        ]
      },
      {
        path: 'cataloghi',
        data: { name: 'Cataloghi' },
        loadChildren: () => import('../../modules/catalog/catalog.module').then(m => m.CatalogModule)
      },
      {
        path: 'social', 
        data: {name: 'Social', cmsPath: 'landing-page'},
        component: LandingComponent,
        children: [
          {
            path: '**',
            component: LandingComponent
          }
        ]
      }
    ]
  }

];



@NgModule({
  declarations: [
    LandingComponent,
    LandingHolidayComponent,
    LandingCruiseComponent,
    LandingCustomComponent,
    LandingSitePageComponent
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    FormsModule,
    HolidayDetailPageModule,
    CruiseDetailPageModule,
    CustomPageModule,
    NewsletterLandingPageModule,
    RouterModule.forChild(routes)
  ],
  bootstrap: [LandingComponent]
})
export class LandingModule { }
